import { PaletteOptions } from '@mui/material';

export type PalletConfig = Pick<
  PaletteOptions,
  'primary' | 'secondary' | 'background' | 'text'
>;

export const getPalette = (config: PalletConfig) => {
  return {
    mode: 'light' as const,
    ...config,
    action: {
      selected: 'rgb(3,92,140, 0.08)',
      hover: '#fff4e8',
    },
    success: {
      main: '#16A04B',
      light: '#A4DBA4',
      dark: '#2A4E42',
    },
    error: {
      main: '#F44336',
      light: '#EF5350',
    },
  } satisfies PaletteOptions;
};
